import React from 'react';
import {Form} from 'react-final-form';
import {FormattedMessage} from "react-intl";
import arrayMutators from 'final-form-arrays';
import MembersFiltersFields from './Members.Filters.Fields';
import {filtersValidation, prepareFilters} from './Members.Filters.utils';
import Styled from './styled/StyledMember.Filters'
import Apply from "components/Button/styled/StyledApply";

const MembersFiltersList = ({filters, setFilters}) => {
  const onSubmit = (values) => {
    setFilters({
      ...(filters?._q && {q: filters._q}),
      ...prepareFilters(values.filter)
    });
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{filter: filters?.filter || []}}
      validate={filtersValidation}
      mutators={{
        ...arrayMutators
      }}
      render={({handleSubmit, form}) => (
        <form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Styled.MembersFiltersList>
            <MembersFiltersFields
              name="filter"
              filters={filters}
              form={form}
            />
            <Apply 
              type="button"
              onClick={() => {
                form.submit();
              }}
            >
              <FormattedMessage id="Filters.Apply"/>
            </Apply>
          </Styled.MembersFiltersList>
        </form>
      )}
    />
  );
};

export default MembersFiltersList;